import logo from "assets/img/Auth/trimmed-logo.png";

export const LoadingOverlay = () => (
  <div className="absolute z-50 top-0 left-0 flex h-full w-full flex-1 justify-center items-center bg-gray-100 opacity-50">
    <img src={logo} alt="Logo spinner" className="w-auto h-12  animate-spin" />
  </div>
);
